module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9pw3sg/image/9781488039904.jpg?1703937625948",
      "alt": "This image is the cover for the book Their Forever Home"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Their Forever Home\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this heartwarming romance, a beautiful contractor and a handsome designer pair up to renovate a house . . . and perhaps build something new.")]), _c('br'), _c('br'), _vm._v("Construction expert Cassie Lowman has been paired with the last designer she wanted for Detroit’s new home reno contest. John Robison finds Cassie intriguing yet intimidating. When tough family issues arise, John and Cassie are forced to see each other’s strengths and work together on all fronts, and yes, maybe fall for each other along the way . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Syndi Powell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Syndi Powell started writing stories when she was young to help her find out what happened after the happily ever after in her favorite stories and has made it a lifelong pursuit. She’s been reading Harlequin romance novels since she was in her teens and is thrilled to join their team. She lives near Detroit with her husband, stepson, and a cat and dog who believe they run the household. She loves to connect with readers on Twitter @syndipowell or on Facebook.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0